/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuid from 'uuid/v4';
import GenericButton from '../common/GenericButton';
import * as CrosstabUtils from '../../util/CrosstabUtils';
import Modal from '../common/Modal/Modal';
import StudySelector from '../common/StudySelector';
import DraggableToolPaletteHeader from '../crosstab/DraggableToolPaletteHeader';
import DraggableToolPaletteGrid from '../crosstab/DraggableToolPaletteGrid';
import * as crosstabActions from '../../actions/crosstabActions';
import * as studyActions from '../../actions/studyActions';
import * as dictionaryActions from '../../actions/dictionaryActions';
import * as quickReportsActions from '../../actions/quickReportsActions';
import { saveTrackingData, getActionName } from '../../util/trackerUtils';
import { TOOL_VIEW_CLEAR_ALL, TOOL_TARGET_CLEAR_ALL, ACTION_TYPE_TOOL_GRID, FLEX_STUDY_TAG } from '../../constants';

const modalStyle = {
  width: 'auto',
  minWidth: '770px',
  maxWidth: '800px',
  height: 'auto',
  top: '5%',
  left: '24%',
};

const afterOpenCrosstabModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const defaultColumnHeaderDef = {
  label: '',
  name: '',
  sortOrder: CrosstabUtils.SORT_DIRECTION.NONE,
  sortKey: '',
};

const defaultCount = {
  BasesDataGrid: 1,
  StandardBases: 1,
  ColumnsDataGrid: 5,
  DataHaulBasesDataGrid: 1,
  DataHaulColumnsDataGrid: 5,
  RowsDataGrid: 10,
  VisaTargetDataGrid: 5,
};

class StoriesToolPalette extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crosstabStudy: props.crosstabStudy,
      crosstabTitle: 'Untitled',
      trendStudies: props.trendStudies || [],
      studies: props.studies && props.studies.length > 0 ? props.studies : [],
      activeCrosstabTable: props.activeCrosstabTable ? props.activeCrosstabTable : {},
      RowsDataGrid: props.rows || [],
      ColumnsDataGrid: props.columns || [],
      BasesDataGrid: props.bases || [],
      VisaTargetDataGrid: props.visaTarget || [],
      DataHaulBasesDataGrid: props.DataHaulBases || [],
      DataHaulColumnsDataGrid: props.DataHaulColumns || [],
      showMore: {
        BasesDataGrid: false,
        StandardBases: false,
        RowsDataGrid: false,
        ColumnsDataGrid: false,
        VisaTargetDataGrid: false,
        DataHaulBasesDataGrid: false,
        DataHaulColumnsDataGrid: false,
      },
      activeChartType: CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE,
      shouldExportResult: false,
      selectedBase: props.selectedBase,
      selectedOptions: {},
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.crosstabTableList !== nextProps.crosstabTableList) {
      if (nextProps.crosstabTableList && nextProps.crosstabTableList.length > 0) {
        const activeCrosstabTable = nextProps.crosstabTableList.filter(
          crosstabTable => crosstabTable.isActive,
        )[0];
        if (this.state.activeCrosstabTable === activeCrosstabTable) {
          // InActive entry deleted
          this.setState({ crosstabTableList: nextProps.crosstabTableList });
        } else {
          this.setState({
            crosstabTableList: nextProps.crosstabTableList,
            columnDefinitions: activeCrosstabTable.columnHeaderList.map(
              columnHeader => ({
                ...defaultColumnHeaderDef,
                ...columnHeader,
              }),
            ),
            shouldExportResult: true,
            activeCrosstabTable,
          });
          this.props.crosstabActions.setActiveCrosstabTable(activeCrosstabTable);
        }
      } else {
        this.setState({
          crosstabTableList: [],
          activeCrosstabTable: {},
        });
      }
    }
    if (this.props.crosstabStudy !== nextProps.crosstabStudy) {
      this.setState({
        crosstabStudy: nextProps.crosstabStudy,
        shouldExportResult: false,
      });
    }
    if (this.props.trendStudies !== nextProps.trendStudies) {
      this.setState({ trendStudies: nextProps.trendStudies });
    }
    if (nextProps.studies && this.props.studies !== nextProps.studies) {
      this.setState({
        studies: nextProps.studies,
        shouldExportResult: false,
      });
    }
    if (nextProps.selectedBase !== this.props.selectedBase) {
      this.setState(() => ({ selectedBase: nextProps.selectedBase }));
    }
    if (nextProps.visaTarget !== this.props.visaTarget && nextProps.visaTarget) {
      if (this.toggle10) {
        this.toggle10.checked =
          (nextProps.rows && nextProps.rows.length > 0) ||
          (nextProps.columns && nextProps.columns.length > 0) ||
          (nextProps.bases && nextProps.bases.length > 0);
      }
      if (nextProps.visaTarget !== this.props.visaTarget &&
        nextProps.visaTarget) {
        this.toggle10.checked =
          nextProps.visaTarget && nextProps.visaTarget.length > 0;
        this.toggle11.checked =
          nextProps.visaTarget && nextProps.visaTarget.length > 0;
        this.setState({
          VisaTargetDataGrid: nextProps.visaTarget,
          shouldExportResult: false,
        });
      }
    }
    if (this.props.savedCrosstabs !== nextProps.savedCrosstabs) {
      this.setState({ savedCrosstabs: nextProps.savedCrosstabs });
      this.savedCrosstabsModal.show();
    }
  }

  getActiveClass = chartType =>
    chartType === this.state.activeChartType ? 'active-chart-type' : '';

  getSelectedTargets = gridType =>
    this.state[gridType].filter(
      gridData => this.state.selectedOptions[gridData.id] >= 0,
    );

  handleTargetDrop = (gridData, destinationGridType) => {
    if (destinationGridType !== gridData.gridType) {
      const newGridData = gridData.selectedNodes.map(node => ({
        ...node,
        id: uuid(),
      }));
      this.props.crosstabActions.updateSampleWeighted(
        [...this.state[destinationGridType], ...newGridData],
        destinationGridType,
      );
      this.setState({ selectedBase: newGridData[0].id });
    }
  };

  showMoreItems = (data, dataGrid) => {
    if (data.length > defaultCount[dataGrid] && this.state.showMore[dataGrid]) {
      return this.renderGrids(data.slice(defaultCount[dataGrid]), dataGrid);
    }
    return null;
  };

  showMoreLabel = (data, dataGrid) => {
    if (data.length > defaultCount[dataGrid]) {
      if (this.state.showMore[dataGrid]) {
        return (
          <button
            type="button"
            className="more-btn"
            onClick={() => this.setState(prevState => ({
              showMore: { ...prevState.showMore, [dataGrid]: false } }))}
          >
            <strong>Less</strong>
          </button>
        );
      }
      return (
        <button
          type="button"
          className="more-btn"
          onClick={() => this.setState(prevState => ({ showMore: { ...prevState.showMore, [dataGrid]: true } }))}
        >
          <strong title={this.state.selectedBase}>More</strong>
        </button>
      );
    }
    return null;
  };

  handleDelete = (currentObjectId, gridType) => {
    this.props.crosstabActions.updateSampleWeighted(
      this.state[gridType].filter(
        crosstabEntry => crosstabEntry.id !== currentObjectId,
      ),
      gridType,
    );
  };

  updateGridData = (currentObject, updatedObjectProps, gridType) => {
    const updatedObject = { ...currentObject, ...updatedObjectProps };
    this.props.crosstabActions.updateSampleWeighted(
      this.state[gridType].reduce((acc, currentValue) => {
        if (currentValue.id === updatedObject.id) {
          acc.push({
            ...currentValue,
            ...updatedObject,
          });
        } else {
          acc.push(currentValue);
        }
        return acc;
      }, []),
      gridType,
    );
  };

  showWarningOpenCrosstab = () => {
    if (this.props.crosstabTableList && this.props.crosstabTableList.length) {
      this.afterOpenCrosstabModal.show();
    }
  };

  selectGridItem = (e, gridEntryid, index) => {
    if (e.ctrlKey || e.metaKey) {
      this.setState(prevState => ({
        selectedOptions: {
          ...prevState.selectedOptions,
          [gridEntryid]: index,
        },
      }));
    } else if (e.shiftKey) {
      console.warn(gridEntryid);
    } else {
      this.setState({
        selectedOptions: {
          [gridEntryid]: index,
        },
      });
    }
  };

  deleteSelected = gridType => {
    this.props.crosstabActions.updateSampleWeighted(
      this.state[gridType].filter(
        gridData => !(this.state.selectedOptions[gridData.id] >= 0),
      ),
      gridType,
    );
  };

  clearSelected = () => {
    this.callSaveTrackerFn({ action: TOOL_VIEW_CLEAR_ALL });
    this.props.crosstabActions.clearSampleWeighted('ColumnsDataGrid');
    this.props.crosstabActions.clearSampleWeighted('RowsDataGrid');
    this.props.crosstabActions.clearSampleWeighted('BasesDataGrid');
    this.props.crosstabActions.clearSampleWeighted('ScratchDataGrid');
    this.props.crosstabActions.deleteCrosstabGrid();
    this.props.crosstabActions.setSelectedBase(
      CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
      CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
      CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE);
    this.props.studyActions.clearTrendStudies();
    this.props.resetHighlightFilterState();
    this.props.crosstabActions.clearSampleWeightedKPIs();
    this.props.quickReportsActions.clearSampleWeightedKPIs();
    this.props.dictionaryActions.setDataPointAlreadyAdded(false);
    this.props.dictionaryActions.dictionaryTargetReset();
    this.props.resetSmarchSearch();
    this.props.resetTitle();
  };

  isEditButtonEnabled = gridType => {
    const selectedGridEntries = this.state[gridType].filter(
      gridData => this.state.selectedOptions[gridData.id] >= 0,
    );
    if (selectedGridEntries.length === 1) {
      return 'edit-selected';
    }
    return 'edit-selected hidden';
  };

  handleEditButton = gridType => {
    const action = getActionName(ACTION_TYPE_TOOL_GRID, gridType);
    if (action) {
      this.callSaveTrackerFn({ action });
    }
    const selectedGridEntries = this.state[gridType].filter(
      gridData => this.state.selectedOptions[gridData.id] >= 0,
    );
    if (selectedGridEntries.length === 1) {
      this.props.handleCrosstabEdit(
        selectedGridEntries[0].id,
        selectedGridEntries[0].dataSmartSearch,
        selectedGridEntries[0].keyword,
      );
    }
  };

  closeLoadCrosstabModal = () => {
    this.savedCrosstabsModal.hide();
    this.showWarningOpenCrosstab();
  };

  callSaveTrackerFn = ({ action }) => {
    const productNo = this.props.crosstabStudy !== undefined ?
      this.props.crosstabStudy.pn : undefined;
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName: this.props.dataScreen !== undefined ? this.props.dataScreen : 'Crosstab',
      action,
    });
  }

  renderLength = data => (data ? data.length : 0);

  renderRowsColumnsBases = (data, dataGrid) => (
    this.renderGrids(data.slice(0, defaultCount[dataGrid]), dataGrid)
  );

  renderToggleButton = (gridEntryId, gridType) => {
    if (gridType === 'BasesDataGrid' || gridType === 'StandardBases') {
      return (
        <span className="radio-toggle">
          <label className="rb-switcher blue" htmlFor={gridEntryId}>
            <input
              type="radio"
              name="study"
              id={gridEntryId}
              checked={this.state.selectedBase === gridEntryId}
              onClick={() => this.handleBaseSelectionChange(gridEntryId, gridType)}
            />{' '}
            <i />
          </label>
        </span>
      );
    }
    return false;
  };

  updateCrosstabTitleHeader = updatedData => {
    let gridCategory = '';
    let originalList = [];
    let index = 0;
    switch (updatedData.gridCategory) {
      case 'ColumnsDataGrid': gridCategory = 'column'; break;
      case 'RowsDataGrid': gridCategory = 'row'; break;
      default: gridCategory = '';
    }
    if (gridCategory !== '' && gridCategory === 'column') {
      originalList = this.props.crosstabColumns;
    } else {
      originalList = this.props.crosstabRows;
    }
    if (originalList.length !== 0) {
      index = originalList.findIndex(item => {
        if (item.keyword === updatedData.keyword) {
          return true;
        }
        return false;
      });
      updatedData.index = index;
    }
    this.props.crosstabActions.updateCrosstabTitleHeader(updatedData);
  }

  renderGrids = (gridData, gridType) =>
    gridData.map((gridEntry, index) => (
      <DraggableToolPaletteGrid
        key={gridEntry.id}
        gridEntry={gridEntry}
        index={index}
        gridType={gridType}
        getSelectedTargets={this.getSelectedTargets}
        handleBaseSelectionChange={
          this.state.crosstabStudy &&
          !this.state.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
            ? this.handleBaseSelectionChange
            : undefined
        }
        selectedOptions={this.state.selectedOptions}
        selectGridItem={this.selectGridItem}
        selectedPreviewItems={() =>
          this.state[gridType].filter(
            grid => this.state.selectedOptions[grid.id] >= 0,
          )
        }
        renderToggleButton={
          this.state.crosstabStudy &&
          !this.state.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
            ? this.renderToggleButton
            : undefined
        }
        handleTargetDrop={this.handleTargetDrop}
        updateGridData={this.updateGridData}
        crosstabStudy={this.state.crosstabStudy.st}
        updateCrosstabTitleHeader={this.updateCrosstabTitleHeader}
        toggleLabelFlag
      />
    ));

  render() {
    return (
      <div className="width-20 minimize-tp float-left">
        <ul className="accordion tool_bg">
          <li className="accordion__item">
            <input
              type="checkbox"
              className="accordion__toggle"
              id="toggle-10"
              ref={node => {
                this.toggle10 = node;
                return this.toggle10;
              }}
            />
            <label
              className="accordion__trigger tool_img grid_tool"
              htmlFor="toggle-10"
              title="Grid"
            >
              Grid
            </label>
            <div className="accordion__target">
              <ul className="marginl_5">
                <li className="accordion__item">
                  <input
                    type="checkbox"
                    className="accordion__toggle"
                    id="toggle-11"
                    ref={node => {
                      this.toggle11 = node;
                      return this.toggle11;
                    }}
                  />
                  <DraggableToolPaletteHeader
                    renderLength={this.renderLength}
                    toggleNo="toggle-11"
                    title="TARGETS"
                    dataGridItems={this.state.VisaTargetDataGrid}
                    handleTargetDrop={this.handleTargetDrop}
                    gridType="VisaTargetDataGrid"
                    icon="targets_tool"
                    study={
                      this.state.crosstabStudy
                        ? this.state.crosstabStudy.study
                        : undefined
                    }
                  />
                  <div className="accordion__target">
                    <div className="">
                      <span
                        className="clear-all"
                        onClick={() => {
                          this.props.crosstabActions.clearSampleWeighted(
                            'VisaTargetDataGrid',
                          );
                          this.callSaveTrackerFn({ action: TOOL_TARGET_CLEAR_ALL });
                        }
                        }
                      >
                        CLEAR ALL
                      </span>
                      <span
                        className={this.isEditButtonEnabled(
                          'VisaTargetDataGrid',
                        )}
                        onClick={() =>
                          this.handleEditButton('VisaTargetDataGrid')
                        }
                      />
                      <span
                        className="delete-selected"
                        onClick={() =>
                          this.deleteSelected('VisaTargetDataGrid')
                        }
                      />
                    </div>
                    {this.renderRowsColumnsBases(
                      this.state.VisaTargetDataGrid,
                      'VisaTargetDataGrid',
                    )}
                    {this.showMoreItems(
                      this.state.VisaTargetDataGrid,
                      'VisaTargetDataGrid',
                    )}
                    {this.showMoreLabel(
                      this.state.VisaTargetDataGrid,
                      'VisaTargetDataGrid',
                    )}
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <Modal
          title="Select Current Study"
          ref={node => {
            this.studyModal = node;
            return this.studyModal;
          }}
          dialogStyles={modalStyle}
        >
          <StudySelector
            handleParentHide={() => this.studyModal.hide()}
            selectedStudy={this.state.crosstabStudy}
            selectedModule={this.props.dataScreen}
          />
        </Modal>
        <Modal
          title="Run Crosstab"
          ref={node => {
            this.afterOpenCrosstabModal = node;
            return this.afterOpenCrosstabModal;
          }}
          dialogStyles={afterOpenCrosstabModalStyle}
        >
          <p>Please run the crosstab after loading.</p>
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => this.afterOpenCrosstabModal.hide()}
          />
        </Modal>
      </div>
    );
  }
}

StoriesToolPalette.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
  bases: PropTypes.arrayOf(PropTypes.object),
  visaTarget: PropTypes.arrayOf(PropTypes.object),
  savedCrosstabs: PropTypes.arrayOf(PropTypes.object),
  studies: PropTypes.arrayOf(PropTypes.object),
  trendStudies: PropTypes.arrayOf(PropTypes.object),
  crosstabTableList: PropTypes.arrayOf(PropTypes.object),
  crosstabStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
      universityUser: PropTypes.bool,
    }),
  }),
  crosstabActions: PropTypes.shape({
    updateSampleWeighted: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
    deleteCrosstabGrid: PropTypes.func,
    clearSampleWeightedKPIs: PropTypes.func,
    setSelectedBase: PropTypes.func,
    setActiveCrosstabTable: PropTypes.func,
    updateCrosstabTitleHeader: PropTypes.func,
    fetchStandardBaseList: PropTypes.func,
  }),
  quickReportsActions: PropTypes.shape({
    clearSampleWeightedKPIs: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    dictionaryTargetReset: PropTypes.func,
    setDataPointAlreadyAdded: PropTypes.func,
  }),
  studyActions: PropTypes.shape({
    clearTrendStudies: PropTypes.func,
  }),
  activeAccountId: PropTypes.number,
  handleCrosstabEdit: PropTypes.func,
  dataScreen: PropTypes.string,
  resetSmarchSearch: PropTypes.func,
  resetHighlightFilterState: PropTypes.func,
  resetTitle: PropTypes.func,
  activeCrosstabTable: PropTypes.shape({}),
  DataHaulBases: PropTypes.arrayOf({}),
  DataHaulColumns: PropTypes.arrayOf({}),
  selectedBase: PropTypes.string,
  crosstabColumns: PropTypes.arrayOf({}),
  crosstabRows: PropTypes.arrayOf({}),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    crosstabStudy: state.study.crosstabStudy,
    trendStudies: state.study.trendStudies,
    savedCrosstabs: state.crosstab.savedCrosstabs,
    crosstabTableList: state.crosstab.crosstabTableList,
    studies: state.study.studies,
    selectedBase: state.selectedBase.selectedBase,
    activeCrosstabTable: state.crosstab.activeCrosstabTable,
    crosstabColumns: state.crosstab.ColumnsDataGridData,
    crosstabRows: state.crosstab.RowsDataGridData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StoriesToolPalette);
